<div class="login-page">
  <div class="login-header">
    <img src="assets/images/logos/nexus-d.png" alt="Logo" class="logo" />
  </div>

  <div class="login-card">
    <router-outlet></router-outlet>
  </div>

  <div class="login-footer">
    <span class="text-xs">© 2025 Misión Empresarial. Todos los derechos reservados.</span>
  </div>
</div>
